import { RouterStateSnapshot, ActivatedRouteSnapshot, Router, Route, CanLoad, CanActivate } from '@angular/router';
import { Injectable, ViewEncapsulation, Inject } from '@angular/core';
import { CommonEnum } from './common-enum';
import { Logger } from 'angular2-logger/core';

import { SharedService } from '../shared/shared.service';
import { environment } from '../../environments/environment';
import {LOCAL_STORAGE, WebStorageService} from 'angular-webstorage-service';



@Injectable()
export class AuthorizatedAgentGuard implements CanActivate {
  public url: string;
  datoUsuario: any;

  constructor(
    private _router: Router,
    private _sharedService: SharedService,
    private logger: Logger,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService
  ) {
    this.url = window.location.href;

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (environment.ActivateGuard) {

      // gets users data and redirects.
      let data = {
        auth_token: this._sharedService.getCookie(CommonEnum.cookieName)
      };

      if (data.auth_token) { // token exists
        if (this._sharedService.user) { // the user has already been initiliazed.
          this.evaluaTipoUser();
        } else { // the user need to be initialized.
          this._sharedService.getCurrent(data).subscribe(
            data => {
              if (data.status) {
                this._sharedService.user = data.data;

                this.storage.set('Usuario', this._sharedService.user);
                this.datoUsuario = this.storage.get('Usuario');
                //console.log('Este es el local Storage: ', this.datoUsuario);

                this.logger.log('User data recovered on guard!');
                this.logger.log(data.data);
                this.evaluaTipoUser();
              } else {
                this.logger.log(data.message);
                this.letsRedirectAuth();
                return false;
              }
            },
            error => { //  other error
              console.log("Acá");
              this.logger.log(error);
              this.letsRedirectAuth();
              return false;
            }
          );

        }
        return true;

      } else { // user don't have token
        this.logger.log("Guard Agent: don't have cookie.");
        this.letsRedirectAuth();
      }
    } else {
      return true;
    }

  }

  evaluaTipoUser() {
    if (this._sharedService.user.role_id === 3 || this._sharedService.user.role_id === 1 || this._sharedService.user.role_id === 5 || this._sharedService.user.role_id === 6) {
      this.logger.log('es un Agent o Admin!');
      return true;
    } else {
      this.logger.log("Guard Agent: type User by cookie");
      this.letsRedirectAuth();
      return false;
    }
  }

  letsRedirectAuth() {
    this.logger.log("tried to redirect to auth");
    this._sharedService.setCookie(CommonEnum.cookieName, '', -1, environment.c_domain);
    this._router.navigate(["./auth"]);
  }

  letsRedirectDashboard() {
    this.logger.log("tried to redirect to dash");
    this._router.navigate(["./dashboard"]);
  }

}


// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend/src/app/guard/authorizated-agent.guard.ts